import {
  MdAddCard,
  MdOutlineCreditCardOff,
  MdPercent,
  MdTimelapse,
} from 'react-icons/md';
import { PerformanceReportResume } from 'types';
import { BigNumberCard, CARD_STATUS, Loading } from 'components';
import { formatMillisecondsToHours } from 'helpers';
import * as S from './styles';

interface Props {
  performanceResume?: PerformanceReportResume;
  isResumeLoading: boolean;
}

export function ScoreBigNumbers({ performanceResume, isResumeLoading }: Props) {
  if (isResumeLoading) {
    return (
      <S.CardsWrapper>
        <Loading />
      </S.CardsWrapper>
    );
  }

  if (!performanceResume) {
    return null;
  }

  const {
    confirmedPercentage,
    confirmedQuantity,
    revokedQuantity,
    timeActionAverage,
  } = performanceResume;

  const { hours, minutes, seconds } =
    formatMillisecondsToHours(timeActionAverage);
  const avgTimeFormatted = `${hours}:${minutes}:${seconds}`;

  return (
    <S.CardsWrapper>
      <BigNumberCard
        icon={<MdAddCard />}
        title="Pedidos aceitos"
        tooltipText="Pedidos aceitos por sua loja"
        status={CARD_STATUS.POSITIVE}
      >
        {confirmedQuantity}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdOutlineCreditCardOff />}
        title="Pedidos recusados"
        tooltipText="Pedidos recusados por sua loja"
        status={CARD_STATUS.NEGATIVE}
      >
        {revokedQuantity}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdTimelapse />}
        title="Tempo de ação"
        tooltipText="Tempo médio para iniciar o atendimento dos pedidos"
        status={CARD_STATUS.POSITIVE}
      >
        {avgTimeFormatted}
      </BigNumberCard>

      <BigNumberCard
        icon={<MdPercent />}
        title="Porcentagem de aceite"
        tooltipText="Porcentagem de pedidos atendidos"
        status={CARD_STATUS.POSITIVE}
      >
        {confirmedPercentage}%
      </BigNumberCard>
    </S.CardsWrapper>
  );
}
